/**
 * Created by rak on 4/2/2016.
 */
'use strict';
angular.module('betosyswebapp').directive('contextmenu', function () {
  return {
    link: function (elem) {
      $(elem).on('contextmenu', function (e) {
        e.preventDefault();
        return false;
      });
    }
  };
});




// WEBPACK FOOTER //
// ./.tmp/components/common/directives/contextMenuDirective.js